import { LOCATION_CHANGE } from '../authentication/authentication.module';
import { hasValue } from '../../../utils/utils';

export default function automaticEdit(
  state = {
    automaticEditActivityID: [],
    automaticEditInitialized: false,
  },
  { type }
) {
  switch (type) {
    case LOCATION_CHANGE: {
      if (state.automaticEditInitialized) {
        return state;
      }
      const activityIDs = /activityIDs?=?([\w-]+)?/.exec(
        window.location.search
      );
      return {
        ...state,
        automaticEditInitialized: true,
        automaticEditActivityID: hasValue(activityIDs) ? [activityIDs[1]] : [],
      };
    }
    default:
      return state;
  }
}
